import cx from 'classnames'
import {ComponentElement, Fragment} from 'react'
import {FoldingProvider, StepCode} from '../../../providers/FoldingProvider'
import {Availability} from './Availability/Availability'
import {Calendar} from './Calendar/Calendar'
import {Guests} from './Guests/Guests'
import {Options} from './Options/Options'

type Props = {
  className?: string
}

export const Steps = ({className}: Props) => {
  const orderedStepCodes = FoldingProvider.useOrderedStepCodes()

  const steps: Record<StepCode, ComponentElement<any, any>> = {
    guests: <Guests />,
    date: <Calendar />,
    option: <Options />,
    availability: <Availability />,
  }

  return (
    <div className={cx('flex flex-col gap-4', className)}>
      {orderedStepCodes.map((code) => {
        return <Fragment key={code}>{steps[code]}</Fragment>
      })}
    </div>
  )
}
